module.exports = __webpack_public_path__ + "img/mediclub-logo-oneline-white.fc0ec94.svg";